module.exports = __webpack_public_path__ + "img/scale.328c2885.svg";